import {
    useContext,
    useEffect,
    useState
} from 'react';
import Head from 'next/head';

import { RequestNextApi } from '../../../../api/Request';
import { ProgressContext } from '../../../../components/Context/progressContext';
import MarketingNavigation from '../../../../navigation/marketing';
import { ShowNotification } from '../../../../utils/notification/snackbarUtils';
import { showArticleBlock } from '../../../../utils/static-pages/function';


export default function MasterProgram() {
    const [articleBlocks, setArticleBlocks] = useState();
    const { state: progressContext, update: updateProgress } = useContext(ProgressContext);

    useEffect(() => {
        const fetchPage = async () => {
            try {
                const res = await RequestNextApi.post('/pages',
                    {
                        slug: 'mastermind-program'
                    }
                );
                
                if (res.data.success) {

                    setArticleBlocks(res.data.page.articleBlocks);
                } else {
                    ShowNotification.error('Fetch page failed');
                }
            } catch (error) {
                ShowNotification.error('Fetch page failed');
            }
        };

        const initPage = async () => {
            updateProgress({ isLoading: true });
            await fetchPage();
            updateProgress({ isLoading: false });
        };

        initPage();
    }, []);

    return (
        <>
            <Head>
                <title>Kingdom Advisors Conference | Learn. Worship. Connect.</title>
                <meta name="description" content="At the Kingdom Advisors Redeeming Money conference, find your community and learn timeless wisdom to elevate your financial advice." />
            </Head>
            <MarketingNavigation>
                <div className='marketing-home--conference flex flex-col h-full'>
                    {articleBlocks?.map((item, index) => (
                        showArticleBlock(item, index)
                    ))}
                </div>
            </MarketingNavigation>
        </>
    )
}

MasterProgram.getLayout = page => <>{page}</>;
MasterProgram.isPublic = true;
